import { render } from "./GroupCardMessageRawV2.vue?vue&type=template&id=39840c87&scoped=true"
import script from "./GroupCardMessageRawV2.vue?vue&type=script&lang=js"
export * from "./GroupCardMessageRawV2.vue?vue&type=script&lang=js"

import "./GroupCardMessageRawV2.vue?vue&type=style&index=0&id=39840c87&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\a\\WebApp\\FAOU.App\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39840c87"]])

export default __exports__